import React, { useState } from "react";
import { useGetReportByDateQuery } from "../../services/modules/reports";

const ReportPage = () => {
  const today = new Date().toISOString().split("T")[0];
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);

  const { data, isLoading, error } = useGetReportByDateQuery({
    startDate,
    endDate,
  });

  const reportData = data?.data?.result || {};

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Page Report</h2>

      <div className="mb-4 flex gap-4">
        <div>
          <label className="block text-base">Start Date</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="border p-2 rounded"
          />
        </div>
        <div>
          <label className="block text-base">End Date</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="border p-2 rounded"
          />
        </div>
      </div>

      {isLoading && <p>Sto caricando...</p>}
      {error && <p className="text-red-600">Error loading report.</p>}

      {!isLoading && !error && (
        <div className="bg-white p-6 rounded shadow">
          <h3 className="text-lg font-semibold mb-4">Report</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <h4 className="font-bold mb-2">Top Users</h4>
              <table className="min-w-full border text-base">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border px-2 py-1">ID</th>
                    <th className="border px-2 py-1">Utente</th>
                    <th className="border px-2 py-1">Count</th>
                  </tr>
                </thead>
                <tbody>
                  {reportData.topUsers?.map((user, i) => (
                    <tr key={i}>
                      <td className="border px-2 py-1">{i + 1}</td>
                      <td className="border px-2 py-1">{user.name}</td>
                      <td className="border px-2 py-1">{user.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div>
              <h4 className="font-bold mb-2">Top Videos</h4>
              <table className="min-w-full border text-base">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border px-2 py-1">ID</th>
                    <th className="border px-2 py-1">Titolo</th>
                    <th className="border px-2 py-1">Count</th>
                  </tr>
                </thead>
                <tbody>
                  {reportData.topVideos?.map((video, i) => (
                    <tr key={i}>
                      <td className="border px-2 py-1">{i + 1}</td>
                      <td className="border px-2 py-1">{video.title}</td>
                      <td className="border px-2 py-1">{video.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div>
              <h4 className="font-bold mb-2">UOA Stats</h4>
              <table className="min-w-full border text-base">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border px-2 py-1">Unit</th>
                    <th className="border px-2 py-1">Count</th>
                  </tr>
                </thead>
                <tbody>
                  {reportData.uoaStats?.map((uoa, i) => (
                    <tr key={i}>
                      <td className="border px-2 py-1">{uoa.name}</td>
                      <td className="border px-2 py-1">{uoa.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportPage;
